/**
 * Anchor enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file Anchor.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum Anchor {
  None = "none",
  BottomLeft = "bl",
  BottomCenter = "bc",
  BottomRight = "br",
  TopLeft = "tl",
  TopCenter = "tc",
  TopRight = "tr",
  User = "user"
}